import React from "react";

const RouteAdviceContext = React.createContext(null);

export default RouteAdviceContext;